import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  item: {
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },

    '& .MuiListItemText-multiline': {
      marginTop: 0,
    },
  },

  itemIcon: {
    padding: 5,
    borderRadius: 5,
    marginRight: 10,
    minWidth: 'auto',
    backgroundColor: (props) => props.coverColor || theme.color.black,

    '& svg': {
      width: 'auto',
      height: 'auto',
      fill: theme.color.white,
    },
  },
}));
